import React, { useState } from 'react';
import { isEmpty, isFinite } from 'lodash/fp';
import { Redirect, useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useMediaQuery } from '@material-ui/core';
import { useWarehouseCardAction } from '../../providers/WarehouseCardActionProvider';
import { useWarehousesScope } from '../../providers/WarehouseScopeProvider';
import {
    DeductionListItemCascadeCreate,
    StockCardsComponent,
    refetchStockCardsQuery,
    useCreateDeductionListMutation,
} from '../../../../generated/graphql';
import { routePaths } from '../../../../routePaths';
import { Dialog, FullScreenDialog } from '../../../../ui-kit';
import WarehouseCardWriteOffForm, { WriteOffFormValues } from './WarehouseCardWriteOffForm';

const WarehouseCardWriteOff = () => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const history = useHistory();
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const { currentWarehouseId } = useWarehousesScope();
    const { selectedCardIds, setCurrentAction } = useWarehouseCardAction();
    const [runMutation] = useCreateDeductionListMutation({
        refetchQueries: [refetchStockCardsQuery({ warehouseIds: [currentWarehouseId as string] })],
    });

    if (isEmpty(selectedCardIds)) {
        return <Redirect to={routePaths.warehouseCards} />;
    }

    const handleClose = () => {
        setIsDialogOpened(false);
        setTimeout(() => history.push(routePaths.warehouseCards), theme.transitions.duration.leavingScreen);
    };

    const moveBack = () => {
        handleClose();
        setCurrentAction(undefined);
    };

    const onSubmit = async (values: WriteOffFormValues) => {
        const { deductionItems = [], reason } = values;
        const deductionListItems: Array<DeductionListItemCascadeCreate> = [];

        deductionItems.forEach(({
            quantity,
            unitType,
            stockCardId,
        }) => {
            if (isFinite(quantity)) {
                deductionListItems.push({
                    quantity,
                    unitType,
                    stockCardId,
                });
            }
        });

        if (isEmpty(deductionListItems)) {
            moveBack();
            return;
        }

        await runMutation({
            variables: {
                data: {
                    deductionListItems,
                    warehouseId: currentWarehouseId as string,
                    deductionReason: reason,
                }
            }
        });

        moveBack();
    };


    return (
        <StockCardsComponent variables={{ warehouseIds: [currentWarehouseId as string], stockCardsIds: selectedCardIds }}>
            {({ data: { stockCards } }) => {

                if (!stockCards) {
                    return <Redirect to={routePaths.warehouseCards} />;
                }


                return isDesktop ? (
                    <Dialog
                        isOpened={isDialogOpened}
                        onClose={() => {
                            setIsDialogOpened(false);
                            setTimeout(() => history.push(routePaths.warehouseCards), theme.transitions.duration.leavingScreen);
                    }}
                    >
                        <WarehouseCardWriteOffForm stockCards={stockCards} onSubmit={onSubmit} onClose={handleClose} />
                    </Dialog>
                ) : (
                    <FullScreenDialog isOpened={isDialogOpened}>
                        <WarehouseCardWriteOffForm stockCards={stockCards} onSubmit={onSubmit} onClose={handleClose} />
                    </FullScreenDialog>
                );
        }}
        </StockCardsComponent>
    );
};

export default WarehouseCardWriteOff;
